/** @format */

import axios, { AxiosRequestHeaders } from 'axios';

const isDev = false;

export const baseURL = isDev
  ? 'http://localhost:3001'
  : 'https://api.cynage.com.au';

export const frontendURL = isDev
  ? 'http://localhost:5173'
  : 'https://app.cynage.com.au';

export const localFrontendURL = isDev
  ? 'http://localhost:5173'
  : 'https://app.cynage.com.au';

export const socketURL = baseURL;

const API = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers = config.headers || ({} as AxiosRequestHeaders);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
